import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { MOCK_USER } from '../data/mockData';

const { FiSearch, FiBell, FiMenu } = FiIcons;

export default function Topbar({ onMenuClick }) {
  return (
    <header className="h-16 glass-panel border-x-0 border-t-0 flex items-center justify-between px-6 z-10">
      <div className="flex items-center gap-4 flex-1">
        <button className="md:hidden text-gray-400 hover:text-cyan-400" onClick={onMenuClick}>
          <SafeIcon icon={FiMenu} className="text-2xl" />
        </button>
        
        <div className="hidden md:flex items-center bg-violet-950/50 border border-matrix-border rounded-full px-4 py-1.5 w-64 focus-within:w-96 focus-within:border-cyan-400 focus-within:shadow-neon transition-all duration-300">
          <SafeIcon icon={FiSearch} className="text-gray-400" />
          <input 
            type="text" 
            placeholder="Search transcripts, actions..." 
            className="bg-transparent border-none outline-none text-sm ml-2 w-full text-white placeholder-gray-500 font-mono"
          />
        </div>
      </div>

      <div className="flex items-center gap-6">
        <button className="relative text-gray-400 hover:text-cyan-400 transition-colors">
          <SafeIcon icon={FiBell} className="text-xl" />
          <span className="absolute -top-1 -right-1 w-2 h-2 bg-cyan-400 rounded-full shadow-[0_0_5px_#00F0FF]"></span>
        </button>
        
        <div className="flex items-center gap-3 border-l border-matrix-border/50 pl-6">
          <div className="text-right hidden sm:block">
            <div className="text-sm font-medium text-white">{MOCK_USER.name}</div>
            <div className="text-xs text-cyan-400 font-mono">{MOCK_USER.role}</div>
          </div>
          <img 
            src={MOCK_USER.avatar} 
            alt="User" 
            className="w-9 h-9 rounded-full border border-cyan-400/50 p-0.5 object-cover"
          />
        </div>
      </div>
    </header>
  );
}